import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal, Button, Row, Col, Container, Accordion } from "react-bootstrap";
import AccountOnboarding from "../Status/AccountOnboarding";
import { Link, useLocation } from "react-router-dom";
import { IconSeqarrow, IconPlanUpgrade2 } from "../../../../../icons/Icons";
import { useSelector, useDispatch } from "react-redux";
import { getAssigneeAsync } from "../../../../../reducers/user-reducers";
import EmptyState from "../../../../../components/EmptyState/EmptyState";

const TeamsModule = () => {
  const dispatch = useDispatch();
  const [accountOnboard, setAccountOnboard] = useState(false);
  const { state } = useLocation();
  const [tabData, setTabData] = useState(state?.operationType);
  const [formDataReady, setFormDataReady] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [sequences, setSequences] = useState([]);
  const [modules, setModules] = useState([]);
  const [teamStatus, setTeamStatus] = useState(null);
  const teamId = state.propsData.teamId;
  const teamDetail = state.propsData.teamDetail;
  const getTabData = (tabKey) => {
    // console.log(tabKey,'tabKey');
    // console.log(teamDetail,'teamDetail');
    setProcesses(
      teamDetail?.allContents &&
        teamDetail?.allContents.filter((item) => item.type === "Process")
    );
    setSequences(
      teamDetail?.allContents &&
        teamDetail?.allContents.filter((item) => item.type === "Sequence")
    );
    setModules(
      teamDetail?.allContents &&
        teamDetail?.allContents.filter((item) => item.type === "Module")
    );
    // if (tabKey === "Processes") {

    // }
    // if (tabKey === "Sequences") {

    // }
    // if (tabKey === "Modules") {

    // }
  };

  useEffect(() => {
    if (tabData) {
      getTabData(tabData);
    }
  }, [tabData]);

  console.log(processes, "processes");
  console.log(sequences, "sequences");
  console.log(modules, "modules");
  const handleButtonClick = (contentId, type) => {
    setFormDataReady(false);
    setAccountOnboard(true);
    const reqBody = {
      teamId: teamId,
      contentId: contentId,
      contentType: type,
    };

    dispatch(getAssigneeAsync(reqBody)).then((res) => {
      setTeamStatus(res?.payload);
      setFormDataReady(true);
    });
  };
  console.log(state, "state");
  return (
    <>
      <div className="pages h-100">
        {/* <header className="pageHeader m-0 pb-0"> */}
        <header className="pageHeader mb-0">
          <Container fluid>
            {/* <Row className="mx-0 align-items-center"> */}
            <Row className="align-items-center">
              {/* <Col className="px-0">
                <h3>Template Library</h3>
              </Col> */}
              <Col className="col-lg-4">
                <div className="d-flex align-items-center gap-2 w-100">
                  <Link to="/accountsetting/manageteams">
                    <span className="arrow left"></span>
                  </Link>

                  <div className="mw-90">
                    {/* <p className="h3 text-gray-200 mb-1">Templates</p> */}
                    <h3 className="text-truncate">{state.operationType}</h3>

                    <ol className="breadcrumb h6 mt-1">
                      <li className="text-gray-1200">Account Settings</li>
                      {/* <li>{state.operationType}</li> */}
                      <li>Manage Teams</li>
                    </ol>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="">
                  <div className="w-100">
                    <ul
                      class="modalTab modalTab authoringNav pt-4 bg-base-100 nav mt-3"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <Link
                          className={`h6 text-gray-100 ${
                            tabData === "Processes" ? "active" : ""
                          }`}
                          onClick={() => setTabData("Processes")}
                        >
                          Processes
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className={`h6 text-gray-100 ${
                            tabData === "Sequences" ? "active" : ""
                          }`}
                          onClick={() => setTabData("Sequences")}
                        >
                          Sequences
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          className={`h6 text-gray-100 ${
                            tabData === "Modules" ? "active" : ""
                          }`}
                          onClick={() => setTabData("Modules")}
                        >
                          Modules
                        </Link>
                      </li>
                      {/* <li class="nav-item" role="presentation">Processes</li>
                <li class="nav-item" role="presentation">Sequences</li>
                <li class="nav-item" role="presentation">Modules</li> */}
                    </ul>
                  </div>
                </div>
              </Col>
              <Col className="px-0 text-end">
                <div className="d-flex justify-content-end align-items-center">
                  {/* <div className="mwidth-268 me-5">
                    <Search
                      placeHolder="Search template"
                      onBlur={setSearchString}
                    />
                  </div> */}
                  {/* <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    onClick={() => onClose(false)}
                  ></button> */}
                </div>
              </Col>
            </Row>
          </Container>
        </header>
        <div className="pageOuter pt-32">
          <Container fluid>
            {tabData === "Processes" && (
              <Row className="relative">
                <div className="col-10">
                  <Accordion className="h-100" defaultActiveKey="0">
                    {processes?.length > 0 ? (
                      <>
                        {processes &&
                          processes.map((pr, pindex) => (
                            <Accordion.Item
                              eventKey={pindex}
                              className="mb-4 cardContent"
                            >
                              <Accordion.Header>
                                <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                                  <div className="col-4 align-items-start">
                                    <div className="">
                                      <p className="text-gray-100 text-md mb-0">
                                        Process
                                      </p>
                                      <p className="font-bold mb-0 text-gray-100">
                                        {pr?.title}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="col-5">
                                    {/* <div
                                  className="text-center"
                                  style={{ width: "max-content" }}
                                >
                                  <p className="text-primary-200 text-md mb-0">
                                    Assignees
                                  </p>
                                  <Button
                                    className="fSubmitMod ms-2"
                                    variant="white"
                                    size="sm"
                                    
                                    onClick={() =>
                                      handleButtonClick(pr.contentId, pr.type)
                                    }
                                  >
                                    <p className="font-bold mb-0 text-gray-100">
                                      {pr?.assignees}
                                      
                                    </p>
                                  </Button>
                                </div> */}
                                  </div>

                                  {/* <div className="col-3">
                          <p className="text-md text-end text-gray-300 mb-0">
                            40 mins
                          </p>
                        </div> */}
                                </div>
                              </Accordion.Header>
                              <div
                                className="text-center position-absolute"
                                style={{
                                  width: "max-content",
                                  left: "60%",
                                  top: "0.813rem",
                                  zIndex: "20",
                                }}
                              >
                                <p className="text-gray-100 text-md mb-0">
                                  Assignees
                                </p>
                                <Button
                                  className="fSubmitMod ms-0"
                                  variant="white"
                                  size="sm"
                                  // onClick={() => setAccountOnboard(true)}
                                  onClick={() =>
                                    handleButtonClick(pr.contentId, pr.type)
                                  }
                                >
                                  <p className="font-bold mb-0 text-gray-100">
                                    {pr?.assignees}
                                    {/* <IconSeqarrow /> */}
                                  </p>
                                </Button>
                              </div>
                              <Accordion.Body className="ps-32">
                                {pr?.subContents &&
                                  pr?.subContents.map((pri, prindex) => (
                                    <>
                                      {pri?.type === "Sequence" && (
                                        <>
                                          <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                                            <div className="align-items-start">
                                              <div className="">
                                                <p className="text-primary-200 text-md mb-0">
                                                  Sequence
                                                </p>
                                                <p className="font-medium mb-0 text-gray-100">
                                                  {pri?.title}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            {pri?.subContents &&
                                              pri?.subContents.map(
                                                (prs, prsindex) => (
                                                  <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                                                    <div className="d-flex gap-3 align-items-center justify-content-start">
                                                      <div className="count text-xs text-gray-200 borderGray">
                                                        {prsindex + 1}
                                                      </div>
                                                      <div>
                                                        <p className="text-primary-200 text-md mb-0">
                                                          Module
                                                        </p>
                                                        <p className="font-medium mb-0 text-gray-100">
                                                          {prs?.title}
                                                        </p>
                                                      </div>
                                                    </div>

                                                    {/* <div>
                                  {" "}
                                  <p className="text-md text-gray-300 mb-0">20 mins</p>
                                </div> */}
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        </>
                                      )}

                                      {pri?.type === "Module" && (
                                        <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                                          <div className="align-items-start">
                                            <div className="">
                                              <p className="text-primary-200 text-md mb-0">
                                                Module
                                              </p>
                                              <p className="font-medium mb-0 text-gray-100">
                                                {pri?.title}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ))}

                                {/* <div className="d-flex justify-content-between align-items-center cardBody noPoint mb-4  ps-0">
                        <div className="d-flex gap-3 align-items-center justify-content-start">
                          <div className="count text-xs text-gray-200">2</div>
                          <div>
                            <p className="text-primary-200 text-md mb-0">
                              Module
                            </p>
                            <p className="font-medium mb-0 text-gray-100">
                              Jira Tutorial
                            </p>
                          </div>
                        </div>
 
                        <div>
                          {" "}
                          <p className="text-md text-gray-300 mb-0">20 mins</p>
                        </div>
                      </div> */}
                                {/* <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                        <div className="align-items-start">
                          <div className="">
                            <p className="text-primary-200 text-md mb-0">
                              Sequence
                            </p>
                            <p className="font-medium mb-0 text-gray-100">
                              Team roles & responsibilities
                            </p>
                          </div>
                        </div>
                      </div> */}
                              </Accordion.Body>
                            </Accordion.Item>
                          ))}
                      </>
                    ) : (
                      <div
                        style={{
                          height: "calc(100vh - 9rem)",
                          position: "absolute",
                          left: "50%",
                          transform: "translate(-50%)",
                        }}
                      >
                        <EmptyState
                          message={"No process found "}
                          className="h-100"
                        />
                      </div>
                    )}
                    {/* <Accordion.Item eventKey="2" className="mb-4 cardContent">
                  <Accordion.Header>
                    <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                      <div className="col-4 align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Process
                          </p>
                          <p className="font-bold mb-0 text-gray-100">
                            Account Onboarding
                          </p>
                        </div>
                      </div>
 
                      <div className="col-5">
                        <p className="text-primary-200 text-md mb-0">
                          Assignees
                        </p>
                        <p className="font-bold mb-0 text-gray-100">
                          234
                          <Button
                            className="fSubmitMod ms-2"
                            variant="white"
                            size="sm"
                            onClick={() => setAccountOnboard(true)}
                          >
                            <IconSeqarrow />
                          </Button>
                        </p>
                      </div>
 
                      <div className="col-3">
                        <p className="text-md text-end text-gray-300 mb-0">
                          40 mins
                        </p>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                      <div className="align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Sequence
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            All About Cerebrent
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200 borderPurple">
                          1
                        </div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
 
                    <div className="d-flex justify-content-between align-items-center cardBody noPoint mb-4  ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200">2</div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                      <div className="align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Sequence
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Team roles & responsibilities
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pb-3 w-100">
                      <div className="align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> */}
                  </Accordion>
                </div>
              </Row>
            )}
            {tabData === "Sequences" && (
              <Row className="relative">
                <div className="col-10">
                  <Accordion className="h-100" defaultActiveKey="0">
                    {sequences?.length > 0 ? (
                      <>
                        {sequences &&
                          sequences.map((sc, sindex) => (
                            <Accordion.Item
                              eventKey={sindex}
                              className="mb-4 cardContent"
                            >
                              <Accordion.Header>
                                <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                                  <div className="col-4 align-items-start">
                                    <div className="">
                                      <p className="text-gray-100 text-md mb-0">
                                        Sequence
                                      </p>
                                      <p className="font-bold mb-0 text-gray-100">
                                        {sc?.title}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="col-5">
                                    {/* <div
                                  className="text-center"
                                  style={{ width: "max-content" }}
                                >
                                  <p className="text-primary-200 text-md mb-0">
                                    Assignees
                                  </p>
                                  <Button
                                    className="fSubmitMod ms-2"
                                    variant="white"
                                    size="sm"
                                   
                                    onClick={() =>
                                      handleButtonClick(sc.contentId, sc.type)
                                    }
                                  >
                                    <p className="font-bold mb-0 text-gray-100">
                                      {sc?.assignees}

                                    </p>
                                  </Button>
                                </div> */}
                                  </div>

                                  {/* <div className="col-3">
                        <p className="text-md text-end text-gray-300 mb-0">
                          40 mins
                        </p>
                      </div> */}
                                </div>
                              </Accordion.Header>
                              <div
                                className="text-center position-absolute"
                                style={{
                                  width: "max-content",
                                  left: "60%",
                                  top: "0.813rem",
                                  zIndex: "20",
                                }}
                              >
                                <p className="text-gray-100 text-md mb-0">
                                  Assignees
                                </p>
                                <Button
                                  className="fSubmitMod ms-0"
                                  variant="white"
                                  size="sm"
                                  // onClick={() => setAccountOnboard(true)}
                                  onClick={() =>
                                    handleButtonClick(sc.contentId, sc.type)
                                  }
                                >
                                  <p className="font-bold mb-0 text-primary-200">
                                    {sc?.assignees}

                                    {/* <IconSeqarrow /> */}
                                  </p>
                                </Button>
                              </div>
                              <Accordion.Body className="ps-32">
                                {sc?.subContents &&
                                  sc?.subContents.map((scm, scmindex) => (
                                    <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                                      <div className="d-flex gap-3 align-items-center justify-content-start">
                                        <div className="count text-xs text-gray-200 borderGray">
                                          {scmindex + 1}
                                        </div>
                                        <div>
                                          <p className="text-primary-200 text-md mb-0">
                                            Module
                                          </p>
                                          <p className="font-medium mb-0 text-gray-100">
                                            {scm?.title}
                                          </p>
                                        </div>
                                      </div>

                                      {/* <div>
                          {" "}
                          <p className="text-md text-gray-300 mb-0">20 mins</p>
                        </div> */}
                                    </div>
                                  ))}

                                {/* <div className="d-flex justify-content-between align-items-center cardBody ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200">2</div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div> */}
                              </Accordion.Body>
                            </Accordion.Item>
                          ))}
                      </>
                    ) : (
                      <div
                        style={{
                          height: "calc(100vh - 9rem)",
                          position: "absolute",
                          left: "50%",
                          transform: "translate(-50%)",
                        }}
                      >
                        <EmptyState
                          message={"No sequence found "}
                          className="h-100"
                        />
                      </div>
                    )}
                    {/* <Accordion.Item eventKey="2" className="mb-4 cardContent">
                  <Accordion.Header>
                    <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                      <div className="col-4 align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Sequence
                          </p>
                          <p className="font-bold mb-0 text-gray-100">
                            Team roles & responsibilities
                          </p>
                        </div>
                      </div>
 
                      <div className="col-5">
                        <p className="text-primary-200 text-md mb-0">
                          Assignees
                        </p>
                        <p className="font-bold mb-0 text-gray-100">
                          234
                          <Button
                            className="fSubmitMod ms-2"
                            variant="white"
                            size="sm"
                            onClick={() => setAccountOnboard(true)}
                          >
                            <IconSeqarrow />
                          </Button>
                        </p>
                      </div>
 
                      <div className="col-3">
                        <p className="text-md text-end text-gray-300 mb-0">
                          40 mins
                        </p>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200 borderPurple">
                          1
                        </div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
 
                    <div className="d-flex justify-content-between align-items-center cardBody ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200">2</div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
                      <div>
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> */}
                  </Accordion>
                </div>
              </Row>
            )}
            {tabData === "Modules" && (
              <Row className="relative">
                <div className="col-10">
                  <Accordion className="h-100" defaultActiveKey="0">
                    {modules?.length > 0 ? (
                      <>
                        {modules &&
                          modules.map((mc, mindex) => (
                            <Accordion.Item
                              eventKey={mindex}
                              className="mb-12 cardContent hide"
                            >
                              <div class="accordion-header">
                                <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                                  <div className="col-4 align-items-start">
                                    <div className="">
                                      <p className="text-gray-100 text-md mb-0">
                                        Module
                                      </p>
                                      <p className="font-bold mb-0 text-gray-100">
                                        {mc?.title}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="col-5">
                                    {/* <div
                                  className="text-center"
                                  style={{ width: "max-content" }}
                                >
                                  <p className="text-primary-200 text-md mb-0">
                                    Assignees
                                  </p>
                                  <Button
                                    className="fSubmitMod ms-2"
                                    variant="white"
                                    size="sm"
                                    
                                    onClick={() =>
                                      handleButtonClick(mc.contentId, mc.type)
                                    }
                                  >
                                    <p className="font-bold mb-0 text-gray-100">
                                      {mc?.assignees}
                                    </p>
                                    
                                  </Button>
                                </div> */}
                                  </div>

                                  {/* <div className="col-3">
                        <p className="text-md text-end text-gray-300 mb-0">
                          40 mins
                        </p>
                      </div> */}
                                </div>
                              </div>
                              <div
                                className="text-center position-absolute"
                                style={{
                                  width: "max-content",
                                  left: "60%",
                                  top: "0.813rem",
                                  zIndex: "20",
                                }}
                              >
                                <p className="text-gray-100 text-md mb-0">
                                  Assignees
                                </p>
                                <Button
                                  className="fSubmitMod ms-0"
                                  variant="white"
                                  size="sm"
                                  // onClick={() => setAccountOnboard(true)}
                                  onClick={() =>
                                    handleButtonClick(mc.contentId, mc.type)
                                  }
                                >
                                  <p className="font-bold mb-0 text-primary-200">
                                    {mc?.assignees}
                                  </p>
                                  {/* <IconSeqarrow /> */}
                                </Button>
                              </div>
                              {/* <Accordion.Body>
                    <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200 borderPurple">
                          1
                        </div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
 
                    <div className="d-flex justify-content-between align-items-center cardBody ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200">2</div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
                  </Accordion.Body> */}
                            </Accordion.Item>
                          ))}
                      </>
                    ) : (
                      <div
                        style={{
                          height: "calc(100vh - 9rem)",
                          position: "absolute",
                          left: "50%",
                          transform: "translate(-50%)",
                        }}
                      >
                        <EmptyState
                          message={"No module found"}
                          className="h-100"
                        />
                      </div>
                    )}
                    {/* <Accordion.Item eventKey="2" className="mb-4 cardContent">
                  <Accordion.Header>
                    <div className="row justify-content-between align-items-center p-12 pe-3 w-100">
                      <div className="col-4 align-items-start">
                        <div className="">
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-bold mb-0 text-gray-100">
                            Team roles & responsibilities
                          </p>
                        </div>
                      </div>
 
                      <div className="col-5">
                        <p className="text-primary-200 text-md mb-0">
                          Assignees
                        </p>
                        <p className="font-bold mb-0 text-gray-100">
                          234
                          <Button
                            className="fSubmitMod ms-2"
                            variant="white"
                            size="sm"
                            onClick={() => setAccountOnboard(true)}
                          >
                            <IconSeqarrow />
                          </Button>
                        </p>
                      </div>
 
                      <div className="col-3">
                        <p className="text-md text-end text-gray-300 mb-0">
                          40 mins
                        </p>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex justify-content-between align-items-center cardBody mb-20 ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200 borderPurple">
                          1
                        </div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
 
                      <div>
                        {" "}
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
 
                    <div className="d-flex justify-content-between align-items-center cardBody ps-0">
                      <div className="d-flex gap-3 align-items-center justify-content-start">
                        <div className="count text-xs text-gray-200">2</div>
                        <div>
                          <p className="text-primary-200 text-md mb-0">
                            Module
                          </p>
                          <p className="font-medium mb-0 text-gray-100">
                            Jira Tutorial
                          </p>
                        </div>
                      </div>
                      <div>
                        <p className="text-md text-gray-300 mb-0">20 mins</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> */}
                  </Accordion>
                </div>
              </Row>
            )}
          </Container>
        </div>
      </div>

      <Modal className="come-from-modal right" centered show={accountOnboard}>
        <AccountOnboarding
          onClose={() => setAccountOnboard(false)}
          teamStatus={teamStatus}
          formDataReady={formDataReady}
        />
      </Modal>
    </>
  );
};

export default TeamsModule;
